<template>
  <v-card class="pa-0 ma-0">
    <v-card-text class="pt-2 pa-1">
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 pa-1>
            <v-text-field label="Ubicazione" v-model="ubicazione" box hide-details :append-icon="'search'"
              @click:append="impostaFocusArticolo()" ref="txtUbicaz"></v-text-field>
          </v-flex>
          <v-flex xs12 pa-1>
            <v-text-field label="Articolo" box hide-details
              :value="$functions.getCodArticoloFormat(datiArticolo.cdArticolo)" :append-icon="'search'"
              v-on:input="cdArticolo = $event" @click:append="caricaDati()" ref="txtArt"></v-text-field>
          </v-flex>
          <v-flex xs12 pa-1>
            <v-textarea label="Descrizione" v-model="datiArticolo.descrizione" box readonly hide-details
              rows="2"></v-textarea>
          </v-flex>
          <v-flex pa-1 :class="getRole == 8 ? 'xs6' : 'xs9'">
            <v-text-field label="Codice fornitore" v-model="datiArticolo.cdArticoloFornitore" box readonly
              hide-details></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-text-field label="UM" v-model="datiArticolo.unMisura" box readonly hide-details></v-text-field>
          </v-flex>
          <!-- Visibile solo su utente Simapac-->
          <v-flex xs3 pa-1 v-if="getRole == 8">
            <v-text-field label="Qta" v-model="datiArticolo.qtaTerzista" box readonly hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pa-1><v-img :src="datiArticolo.urlImg" contain height="200px"></v-img></v-flex>
        </v-layout>

        <!-- Bottone conferma -->
        <v-layout>
          <v-flex xs6 pa-1>
            <v-btn block dark large @click="registraDati()" :loading="attesaConferma" :disabled="attesaConferma"
              color="primary">Conferma</v-btn>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-btn block dark large @click="annulla()" color="primary">Annulla</v-btn>
          </v-flex>
          <v-flex xs1 pa-1>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn style="max-width:50px!important;" v-on="on" flat icon color="primary">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title v-on:click="elimina()">Elimina</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { get_datiArticoli, set_ubicazioni, del_ubicazioni } from "@/api/api.js";

export default {
  data: () => ({
    datiArticolo: {},
    cdArticolo: "",
    ubicazione: "",

    attesaConferma: false
  }),

  methods: {
    caricaDati() {
      // Reset
      this.datiArticolo = {};

      if (!this.cdArticolo) return;

      // Elimino spazi di formattazione codice
      this.cdArticolo = this.$functions.trimAll(this.cdArticolo);

      get_datiArticoli(this.cdArticolo)
        .then(res => {
          this.datiArticolo = res.data;

          // Se ho selezionato prima l'articolo, popolo l'ubicazione
          if (this.ubicazione.length == 0)
            this.ubicazione = this.datiArticolo.ubicazione;
        })
        .catch(err => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => "");
    },

    async registraDati() {
      if (!this.controllaInput()) return;

      let par = {
        CdArticolo: this.cdArticolo,
        Ubicazione: this.ubicazione,
        Ubicazione2: ""
      };

      this.attesaConferma = true;

      try {
        await set_ubicazioni(par);
        // Reset
        this.datiArticolo = {};

        this.impostaFocusArticolo();
      } catch (err) {
        this.$toast.warning(this.$functions.getErrorMsg(err));
      }

      this.attesaConferma = false;
    },

    impostaFocusArticolo() {
      this.$refs["txtArt"].focus();
    },

    controllaInput() {
      // Controllo presenza dati articolo
      if (Object.keys(this.datiArticolo).length == 0) {
        this.$toast.warning("Articolo non valido");
        return false;
      }
      if (this.ubicazione.length == 0) {
        this.$toast.warning("Ubicazione non valida");
        return false;
      }
      return true;
    },

    annulla() {
      // Reset
      this.datiArticolo = {};

      this.cdArticolo = "";
      this.ubicazione = "";

      this.$refs["txtUbicaz"].focus();
    },

    async elimina() {
      if (!this.controllaInput()) return;

      try {
        await del_ubicazioni(this.cdArticolo);

        this.annulla();
      } catch (err) {
        this.$toast.warning(this.$functions.getErrorMsg(err));
      }
    },


  },

  computed: {
    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },

    getRole() {
      return this.$store.getters["user/getRole"];
    },

  },

  watch: {
    getCodebar(v) {
      // NOTA: viene attivato dal lettore codebar

      if (this.$refs.txtArt.isFocused) {
        this.cdArticolo = v.barcodeData;

        this.caricaDati();
      } else {
        this.ubicazione = v.barcodeData;

        this.impostaFocusArticolo();
      }
    }
  }
};
</script>